
document.getElementById('predictive-search-input').addEventListener('input', async function(event) {
  const query = event.target.value;
  const predictiveSearchWrapper = document.querySelector('.predictive-search-result-wrapper');
  const noResults = document.querySelector('.no-results');
  const collectionsBlock = document.querySelector('.collections-block');
  const pagesBlock = document.querySelector('.pages-block');
  const productsBlock = document.querySelector('.inner-products-col');
  const productTag = predictiveSearchWrapper.getAttribute('data-product-tag');
  const showOutOfStockProducts = predictiveSearchWrapper.getAttribute('data-show-outofstock-products') === 'true'; // Convert to boolean
  const clearInputSvg = document.querySelector('.icon-clear-input');

  // Update "View search results for" button
  const viewSearchResultsBtn = document.getElementById('view-search-results');
  if (query.length >= 2) {
    viewSearchResultsBtn.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    viewSearchResultsBtn.textContent = `View search results for '${query}'`; // Update text with query
    viewSearchResultsBtn.style.display = 'block';
  } else {
    viewSearchResultsBtn.style.display = 'none';
  }

  if (query.length < 2) {
    predictiveSearchWrapper.style.display = 'none';
    return;
  } else {
    predictiveSearchWrapper.style.display = 'block';
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 
      `search/suggest.json?q=${encodeURIComponent(query)}&resources[limit_scope]=each&resources[products]=6&resources[collections]=4&resources[pages]=4`);
    const suggestions = await response.json();

    // Clear previous results
    document.querySelector('.collections-ul').innerHTML = '';
    document.querySelector('.pages-ul').innerHTML = '';
    document.querySelector('.products-col').innerHTML = '';

    let hasResults = false;

    // Append collections
    if (suggestions.resources.results.collections.length > 0) {
      hasResults = true;
      collectionsBlock.style.display = 'block';
      suggestions.resources.results.collections.forEach(collection => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = collection.url;
        a.textContent = collection.title;
        li.appendChild(a);
        document.querySelector('.collections-ul').appendChild(li);
      });
    } else {
      collectionsBlock.style.display = 'none';
    }

    // Append pages
    if (suggestions.resources.results.pages.length > 0) {
      hasResults = true;
      pagesBlock.style.display = 'block';
      suggestions.resources.results.pages.forEach(page => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = page.url;
        a.textContent = page.title;
        li.appendChild(a);
        document.querySelector('.pages-ul').appendChild(li);
      });
    } else {
      pagesBlock.style.display = 'none';
    }

    // Append products
    if (suggestions.resources.results.products.length > 0) {
      hasResults = true;
      productsBlock.style.display = 'block';
      const filteredProducts = suggestions.resources.results.products
        .filter(product => !product.tags.includes(productTag)) // Filter out products with the specified tag
        .filter(product => showOutOfStockProducts || product.available); // Filter based on availability

      // Slice and display only the first 6 products
      filteredProducts.slice(0, 6).forEach(product => {
        const productCol = document.createElement('div');
        productCol.classList.add('single-product-col');
        
        const productLink = document.createElement('a');
        productLink.href = product.url;

        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title;

        const title = document.createElement('div');
        title.classList.add('product-title');
        title.textContent = product.title;

        const price = document.createElement('p');
        price.classList.add('product-price');
        const priceSpan = document.createElement('span');
        priceSpan.textContent = '£'+product.price;
        price.appendChild(priceSpan);

        productLink.appendChild(img);
        productLink.appendChild(title);
        productLink.appendChild(price);
        productCol.appendChild(productLink);

        document.querySelector('.products-col').appendChild(productCol);
      });
    } else {
      productsBlock.style.display = 'none';
    }

    // Show "No results found" message if no results in all sections
    if (!hasResults) {
      noResults.style.display = 'block';
      viewSearchResultsBtn.style.display = 'none'; // Hide button when no results
    } else {
      noResults.style.display = 'none';
    }

    clearInputSvg.classList.add('active');

  } catch (error) {
    console.error('Error fetching search suggestions:', error);
  }
});


document.querySelector('.icon-search-svg').addEventListener('click', function() {
  document.querySelector('.predictive-search-input-wrapper').classList.add('active');
});

document.querySelector('.predictive-search-input-wrapper .icon-close-svg').addEventListener('click', function() {
  document.querySelector('.predictive-search-input-wrapper').classList.remove('active');
  document.body.classList.remove('search-open');
  document.querySelector('#predictive-search-input').value = '';

  // Remove all <li> elements from <ul> with class 'collections-ul'
  document.querySelectorAll('ul.collections-ul li').forEach(function(item) {
    item.remove();
  });

  // Remove all <li> elements from <ul> with class 'pages-ul'
  document.querySelectorAll('ul.pages-ul li').forEach(function(item) {
    item.remove();
  });

  // Remove all inner HTML within the <div> with class 'products-col'
  document.querySelector('.products-col').innerHTML = '';

  // Set display: none on <div> with class 'predictive-search-result-wrapper'
  document.querySelector('.predictive-search-result-wrapper').style.display = 'none';
  
});

document.querySelector('.icon-clear-input').addEventListener('click', function() {
  document.querySelector('.icon-clear-input').classList.remove('active');
  document.querySelector('.predictive-search-input-wrapper').classList.remove('active');
  document.body.classList.remove('search-open');
  document.querySelector('#predictive-search-input').value = '';

  // Remove all <li> elements from <ul> with class 'collections-ul'
  document.querySelectorAll('ul.collections-ul li').forEach(function(item) {
    item.remove();
  });

  // Remove all <li> elements from <ul> with class 'pages-ul'
  document.querySelectorAll('ul.pages-ul li').forEach(function(item) {
    item.remove();
  });

  // Remove all inner HTML within the <div> with class 'products-col'
  document.querySelector('.products-col').innerHTML = '';

  // Set display: none on <div> with class 'predictive-search-result-wrapper'
  document.querySelector('.predictive-search-result-wrapper').style.display = 'none';
  
});

// Observe body tag if .search-open class exist, if yes then add active class on predictive search input wrapper

var targetNode = document.querySelector('body');
var config = { attributes: true, attributeFilter: ['class'] };

var callback = function(mutationsList, observer) {
  // Use forEach to iterate over mutationsList
  mutationsList.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      // Check if .search-open exists in the body class list
      if (document.body.classList.contains('search-open')) {
        document.querySelector('.predictive-search-input-wrapper').classList.add('active');
      } else {
        document.querySelector('.predictive-search-input-wrapper').classList.remove('active');
      }
    }
  });
};

var observer = new MutationObserver(callback);
observer.observe(targetNode, config);


// On Enter, Redirect User to result page

var input = document.getElementById("predictive-search-input");
input.addEventListener("keypress", function(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    const query = event.target.value;
    window.location = `/search?q=${encodeURIComponent(query)}&type=product`;
    // alert(query);
  }
});




